import type { Ref } from 'react'
import type { ConnectDragSource, ConnectDropTarget } from 'react-dnd'

// react-dnd's connector is a valid callback ref at runtime, but its return type
// doesn't satisfy React 19's stricter ref type.
export const dndConnectRef = (
  connector: ConnectDragSource | ConnectDropTarget,
): Ref<any> => connector as unknown as Ref<any>
